import React, { useState, useRef } from "react";
import { message, Button, notification } from "antd";
import { ethers } from "ethers";

import "./MintPage.scss";
import { useEffect } from "react";

export default function MintPage(props) {
  const {
    address,
    writeContracts,
    onClickConnect,
  } = props;

  const amountInput = useRef();
  const priceInput = useRef();
  const [amount, setAmount] = useState(1);
  const [price, setPrice] = useState(0.01);
  const [totalSupply, setTotalSupply] = useState(1);

  useEffect(() => {
    async function getTotalSupply() {
      if(!writeContracts || !writeContracts.Phrumps) {
        return;
      }
      const supply = (await writeContracts.Phrumps.totalSupply()).toNumber();
      setTotalSupply(supply);
    }
    getTotalSupply();
  }, [writeContracts]);
  
  async function mint() {
    const parsedAmount = parseFloat(amountInput.current.value);
    if(!parsedAmount) {
      setAmount(0);
      return;
    }

    const parsedPrice = parseFloat(priceInput.current.value);
    if(!parsedPrice) {
      setPrice(0);
      return;
    }

    const cost = ethers.utils.parseEther(parsedPrice.toString()).mul(parsedAmount.toString());
    try {
      const tx = await writeContracts.Phrumps.mint(parsedAmount, { value: cost });
      tx.wait(1).then(receipt => {
        console.log(receipt)
        if(receipt && receipt.events) {
          for(let i = 0; i < receipt.events.length; i++) {
            const event = receipt.events[i];
            if(event.event === "Transfer") {
              message.success(
                <div>
                  <div>Minting success!</div>
                </div>, 5
              );
              break;
            }
          }
        }
      });
    } catch(e) {
      let details = e && e.data && e.data.message ? e.data.message : null;
      if(!details) {
        details = e && e.message ? e.message : null;
      }
      notification.open({
        message: 'Error',
        description: <div>
          Something went wrong creating the transaction for you to sign :(
          {details && <p><br/>{details}</p>}
        </div>
      });
    }
  }

  function connect() {
    onClickConnect();
  }

  return (
    <div className="MintPage">
      { !address &&
        <div>
          <p>Connect your wallet to mint some Phrumps!</p>
          <Button type="primary" shape="round" onClick={connect}>Connect</Button>
        </div>
      }
      { address &&
        <>
          { totalSupply < 45000 &&
            <>
              <div style={{lineHeight: '2.5em'}}>{totalSupply} / 45000 minted</div>
              <div className="minter">
                <span>How many Phrumps do you want to mint?</span>
                <input
                  ref={amountInput}
                  type="number"
                  min="1"
                  max="20"
                  value={amount}
                  onChange={e => setAmount(e.target.value)}
                />
              </div>
              <div className="minter">
                <span>Price per Phrump?</span>
                <input
                  ref={priceInput}
                  type="number"
                  min="0.01"
                  step={0.001}
                  value={price}
                  onChange={e => setPrice(e.target.value)}
                />
                <span>ETH</span>
              </div>
              <div>Total: {Math.round(1000 * price * amount)/1000} ETH</div>
              <br/>
              <Button type="primary" shape="round" onClick={mint}>Mint</Button>
            </>
          }
          { totalSupply >= 45000 &&
            <div>
              SOLD OUT!
              <div>Visit <a href="https://thegivingblock.com/donate/homes-not-borders/" target="_blank" rel="noreferrer">The Giving Block</a> to make a trustless donation to Homes Not Borders</div>
            </div>
          }
        </>
      }
    </div>
  );
};
